import React, { useState } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import zooms from '../../../png/zooms.png';
import close from '../../../svg/close.svg';

const Close = styled.img`
  width: 30px;
  height: 30px;
  position: absolute;
  top: -33px;
  right: 0;
  cursor: pointer;
  transition: 0.3s ease-in-out;
  background: rgba(255, 255, 255, 0.5);
  opacity: 0.8;
  &:hover {
    opacity: 1;
  }
`;

const Date = styled.div`
  position: absolute;
  padding: 5px;
  top: -33px;
  left: 0;
  cursor: pointer;
  transition: 0.3s ease-in-out;
  background: rgba(255, 255, 255, 0.5);
  opacity: 0.8;
  z-index: 1;
  &:hover {
    opacity: 1;
  }
`;

const ZoomIcon = styled.div<{ isIn?: boolean }>`
  width: 30px;
  height: 30px;
  background-image: url(${zooms});
  background-size: 54px;
  background-position: ${(props) => (props.isIn ? '-26px' : '2px')};
  background-repeat: no-repeat;
  cursor: pointer;
  min-width: 30px;
`;

const Mask = styled.div`
  background: rgba(0, 0, 0, 0.7);
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
`;

const Controls = styled.div`
  position: absolute;
  display: flex;
  top: 0;
  left: 50%;
  transform: translate(-51px);
  width: auto;
  height: auto;
  background: rgba(255, 255, 255, 0.5);
  z-index: 99999;
  img {
    width: 30px;
  }
  svg {
    font-size: 35px;
    transition: ease-in-out 0.3s;
    cursor: pointer;
    opacity: 0.6;
    &:hover {
      opacity: 1;
    }
  }
`;

const SLightBox = styled.div`
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  overflow: auto;
  .img {
    z-index: 1;
    left: 0;
    top: 0;
    transform: translate(0, 0);
    position: relative;
    margin: auto;
    right: 0;
    bottom: 0;
    max-height: 90vh;
    max-width: 90vw;
    img {
      max-width: 100%;
      max-height: 100%;
      transition: ease-in-out 0.1s;
    }
  }

  span {
    color: #000;
    cursor: pointer;
    font-weight: bold;
    cursor: pointer;
  }
  button {
    border: 1px solid #fff;
    padding: 10px;
    transition: ease-in-out 0.3s;
    &.edit,
    &.close-details,
    &.add-image {
      font-size: 14px;
    }
    &:hover {
      border: 1px solid #999;
    }
  }
`;

interface IProps {
  mainSrc: string;
  onCloseRequest(): void;
  onClickOutSide(): void;
  next: () => void;
  prev: () => void;
  text: string;
}

const LightBox: React.FC<IProps> = ({
  onClickOutSide,
  onCloseRequest,
  mainSrc,
  prev,
  next,
  text,
}) => {
  const [scale, setScale] = useState(1);

  return (
    <SLightBox>
      <Mask onClick={onClickOutSide} />
      <div className="img">
        <Date>{moment(Number(text)).format('Do MMMM YYYY hh:mm:ss')}</Date>
        <img src={mainSrc} style={{ transform: `scale(${scale})` }} alt="detail" />
        <Close src={close} alt="close" onClick={onCloseRequest} />
      </div>
      <div></div>
      <Controls>
        <span onClick={prev}>←</span>
        <ZoomIcon onClick={() => setScale(scale + 0.2)} isIn />
        <ZoomIcon onClick={() => setScale(scale - 0.2)} />
        <span onClick={next}>→</span>
      </Controls>
    </SLightBox>
  );
};

export default LightBox;
